export default __webpack_public_path__ + "static/media/thumbnail-light.a56de5fc.webp";